module.exports = __webpack_public_path__ + "img/sld_scb_37_t1_b1_green.f175ca1d.svg";